export const CloseIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12.0004 13.05L6.92539 18.125C6.79206 18.2584 6.62139 18.329 6.41339 18.337C6.20472 18.3457 6.02539 18.275 5.87539 18.125C5.72539 17.975 5.65039 17.8 5.65039 17.6C5.65039 17.4 5.72539 17.225 5.87539 17.075L10.9504 12L5.87539 6.92502C5.74206 6.79169 5.67139 6.62069 5.66339 6.41202C5.65472 6.20402 5.72539 6.02502 5.87539 5.87502C6.02539 5.72502 6.20039 5.65002 6.40039 5.65002C6.60039 5.65002 6.77539 5.72502 6.92539 5.87502L12.0004 10.95L17.0754 5.87502C17.2087 5.74169 17.3797 5.67069 17.5884 5.66202C17.7964 5.65402 17.9754 5.72502 18.1254 5.87502C18.2754 6.02502 18.3504 6.20002 18.3504 6.40002C18.3504 6.60002 18.2754 6.77502 18.1254 6.92502L13.0504 12L18.1254 17.075C18.2587 17.2084 18.3294 17.379 18.3374 17.587C18.3461 17.7957 18.2754 17.975 18.1254 18.125C17.9754 18.275 17.8004 18.35 17.6004 18.35C17.4004 18.35 17.2254 18.275 17.0754 18.125L12.0004 13.05Z"
      fill="currentColor"
    />
  </svg>
);
